// extracted by mini-css-extract-plugin
module.exports = {"SocialsDropdown":"SocialsDropdown_SocialsDropdown__2W1ae","dropdownMenu":"SocialsDropdown_dropdownMenu__3SU3p","icon":"SocialsDropdown_icon__1OURx"};